import { createSelector } from "@reduxjs/toolkit";

import {
  StainsState,
  LabStainsState,
  ExternalLabsState,
  ExternalLabStainsState,
} from "../reducers/frontLoaderReducers";

const selectLabStains = createSelector(
  [
    (_state, labId: number) => labId,
    ({ stains }: { stains: StainsState }) => stains,
    ({ labStains }: { labStains: LabStainsState }) => labStains,
    ({ externalLabs }: { externalLabs: ExternalLabsState }) => externalLabs,
    ({ externalLabStains }: { externalLabStains: ExternalLabStainsState }) =>
      externalLabStains,
  ],
  (labId, stains, labStains, externalLabs, externalLabStains) => {
    if (!labId) return [];

    const filteredLabStains = Object.values(labStains).filter(
      (ls) => ls.lab_id === labId
    );

    return filteredLabStains.map((ls) => ({
      ...ls,
      stain: stains[ls.stain_id],
      external_stain: !ls.external_lab_stain_id
        ? undefined
        : {
            ...externalLabStains[ls.external_lab_stain_id],
            stain: stains[externalLabStains[ls.external_lab_stain_id].stain_id],
            external_lab:
              externalLabs[
                externalLabStains[ls.external_lab_stain_id].external_lab_id
              ],
          },
    }));
  }
);

export type MemoizedLabStain = ReturnType<typeof selectLabStains>[0];

export default selectLabStains;
